<template>
	<div id="wysiwyg">
    <div class="tools">
      <div class="group-btn" v-if="hideFile===undefined">
        <a @click="fileNew()" class="" title="Apagar todo o texto"><i class="glyphicon glyphicon-file"></i></a>
        <a @click="" class="hide"><i class="glyphicon glyphicon-folder-open"></i></a>
        <a @click="" class="hide"><i class="glyphicon glyphicon-floppy-disk"></i></a>
        <a @click="" class=""><i class="glyphicon glyphicon-send"></i></a>
      </div>
      <div class="group-btn" v-if="hideBold===undefined">
        <a @click="bold(true)" :class="(btn.bold)? 'on' : ''" title="Negrito"><i class="glyphicon glyphicon-bold"></i></a>
        <a @click="italic(true)" :class="(btn.italic)? 'on' : ''" title="Italico"><i class="glyphicon glyphicon-italic"></i></a>
        <a @click="underline(true)" :class="(btn.underline)? 'on' : ''" title="Sublinhado"><i class="glyphicon glyphicon-text-width"></i></a>
        <a @click="strikeThrough(true)" :class="(btn.strikeThrough)? 'on' : ''"  title="Tachado"><i class="glyphicon glyphicon-gbp"></i></a>
      </div>
      <div class="group-btn" v-if="hideAlign===undefined">
        <a @click="justifyLeft()" :class="(btn.justifyLeft)? 'on' : ''"  title="Esquerda"><i class="glyphicon glyphicon-align-left"></i></a>
        <a @click="justifyCenter()" :class="(btn.justifyCenter)? 'on' : ''" title="Centro"><i class="glyphicon glyphicon-align-center"></i></a>
        <a @click="justifyRight()" :class="(btn.justifyRight)? 'on' : ''" title="Direita"><i class="glyphicon glyphicon-align-right"></i></a>
        <a @click="justifyFull()" :class="(btn.justifyFull)? 'on' : ''" title="Justificado"><i class="glyphicon glyphicon-align-justify"></i></a>
      </div>
      <!-- ForeColor -->
      <div class="group-btn" v-if="hideColors===undefined">
        <a @click="foreColor(true)" :class="(btn.foreColor)? 'on' : ''"><i class="glyphicon glyphicon-text-color"></i></a>
        <a @click="seeFontColors = !seeFontColors" class="" :style="'color:' + foreColorHex " v-if="!seeFontColors"><i class="glyphicon glyphicon-stop"></i></a>
        <template v-if="seeFontColors">
        <a @click="setColor('#000', 'f')" class=""><i class="glyphicon glyphicon-stop"></i></a>
        <a @click="setColor('#a94442', 'f')" class=""><i class="glyphicon glyphicon-stop text-danger"></i></a>
        <a @click="setColor('#337ab7', 'f')" class=""><i class="glyphicon glyphicon-stop text-primary"></i></a>
        <a @click="setColor('#3c763d', 'f')" class=""><i class="glyphicon glyphicon-stop text-success"></i></a>
        <a @click="setColor('#8a6d3b', 'f')" class=""><i class="glyphicon glyphicon-stop text-warning"></i></a>
        <a @click="setColor('#666', 'f')" class=""><i class="glyphicon glyphicon-stop text-muted"></i></a>
        <a @click="setColor('#fff', 'f')" class="" style="color:#aaa"><i class="glyphicon glyphicon-text-background"></i></a>
        </template>
        <a @click="removeFormat('foreColor')" class="" v-if="!seeFontColors"><i class="glyphicon glyphicon-erase"></i></a>
      </div>
      <!-- BackColor -->
      <div class="group-btn" v-if="hideColors===undefined">
        <a @click="backColor(true)" :class="(btn.backColor)? 'on' : ''" title="Cor de Fundo"><i class="glyphicon glyphicon-text-background"></i></a>
        <a @click="seeBackColors = !seeBackColors" class="" :style="'color:' + backColorHex " v-if="!seeBackColors" title="Escolher cor"><i class="glyphicon glyphicon-stop"></i></a>
        <template v-if="seeBackColors">
        <a @click="setColor('#000', 'b')" class=""><i class="glyphicon glyphicon-stop"></i></a>
        <a @click="setColor('#a94442', 'b')" class=""><i class="glyphicon glyphicon-stop text-danger"></i></a>
        <a @click="setColor('#337ab7', 'b')" class=""><i class="glyphicon glyphicon-stop text-primary"></i></a>
        <a @click="setColor('#3c763d', 'b')" class=""><i class="glyphicon glyphicon-stop text-success"></i></a>
        <a @click="setColor('#8a6d3b', 'b')" class=""><i class="glyphicon glyphicon-stop text-warning"></i></a>
        <a @click="setColor('#666', 'b')" class=""><i class="glyphicon glyphicon-stop text-muted"></i></a>
        </template>
        <a @click="removeFormat('backColor')" class="" v-if="!seeBackColors"><i class="glyphicon glyphicon-erase"></i></a>
      </div>
      <!-- Text-size -->
      <div class="group-btn">
        <a @click="fontSize('7')" title="Titulo">T1</a>
        <a @click="fontSize('6')" title="Subtitulo">T2</a>
      </div>
      <div class="group-btn">
        <a @click="insertUnorderedList(true)" :class="(btn.insertUnorderedList)? 'on' : ''"><i class="glyphicon glyphicon-list"></i></a>
        <a @click="insertOrderedList(true)" :class="(btn.insertOrderedList)? 'on' : ''"><i class="glyphicon glyphicon-sort-by-order"></i></a>
        <a @click="superScript(true)" :class="(btn.superScript)? 'on' : ''"><i class="glyphicon glyphicon-superscript"></i></a>
        <a @click="subScript(true)" :class="(btn.subScript)? 'on' : ''"><i class="glyphicon glyphicon-subscript"></i></a>
      </div>
      <div class="group-btn" v-if="hideInserts===undefined">
        <a @click="createLink()" class="" title="Criar Link"><i class="glyphicon glyphicon-link"></i></a>
        <a @click="insertImage()" class=""><i class="glyphicon glyphicon-paperclip"></i></a>
      </div>
    </div>
    <div
    class="resize"
    ref="editor"
    @keyup.enter="handlerKeyEnter()" 
    @mousedown="handlerMouseDown()" 
    @mouseup="handlerMouseUp()"
    @keydown="updateCaretInfo()"
    @keyup="updateCaretInfo()"
    @focus="active = true"
    @focusout="active = false"
    id="editor" contenteditable></div>
    <small><small>{{caret.pathList !== undefined ? caret.pathList : ''}}</small></small>
  </div>
</template>

<script>
export default {
  name: 'agenda',
  props: ['hideFile', 'hideBold', 'hideAlign', 'hideColors', 'hideInserts'],
  data () {
    return {
      active: false,
      caret: {
        hasSelection: false,
        anchorOffset: undefined,
        anchorElText: undefined,
        anchorEl: undefined,
        pathList: undefined
      },
      btn: {
        bold: false,
        italic: false,
        underline: false,
        strikeThrough: false,
        superScript: false,
        subScript: false,
        foreColor: false,
        foreColorHex: 'inherit',
        backColor: false,
        backColorHex: 'inherit',
        insertOrderedList: false,
        insertUnorderedList: false,
        justifyLeft: false,
        justifyCenter: false,
        justifyRight: false,
        justifyFull: false
      },
      seeFontColors: false,
      foreColorHex: 'inherit',
      seeBackColors: false,
      backColorHex: 'inherit',
      seeFontSizes: false,
      selectfontSize: 1
    }
  },
  methods: {
    setContent (html) {
      // console.log('Tentou mudar o conteudo')
      this.$refs.editor.innerHTML = html
    },
    getContent () {
      return this.$refs.editor.innerHTML
    },
    fileNew () {
      this.$refs.editor.innerHTML = ''
    },
    returnCaret4Editor () {
      if (!this.caret.hasSelection) {
        if (this.btn.bold !== document.queryCommandState('bold')) this.bold()
        if (this.btn.italic !== document.queryCommandState('italic')) this.italic()
        if (this.btn.underline !== document.queryCommandState('underline')) this.underline()
        if (this.btn.strikeThrough !== document.queryCommandState('strikeThrough')) this.strikeThrough()
        if (this.btn.superScript !== document.queryCommandState('superScript')) this.superScript()
        if (this.btn.subScript !== document.queryCommandState('subScript')) this.subScript()
        if (this.btn.foreColor && !document.queryCommandState('foreColor')) this.foreColor(false)
        if (this.btn.backColor !== document.queryCommandState('backColor')) this.backColor(false)
        this.btn.insertOrderedList = document.queryCommandState('insertOrderedList')
        this.btn.insertUnorderedList = document.queryCommandState('insertUnorderedList')
        this.btn.justifyLeft = document.queryCommandState('justifyLeft')
        this.btn.justifyCenter = document.queryCommandState('justifyCenter')
        this.btn.justifyRight = document.queryCommandState('justifyRight')
        this.btn.justifyFull = document.queryCommandState('justifyFull')
      }
    },
    returnCaret4LastKnowPosition () {
      let range = document.createRange()
      range.setStart(this.caret.anchorElText, this.caret.anchorOffset)
      range.collapse(true)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    handlerKeyEnter () {
      this.btn.insertOrderedList = document.queryCommandState('insertOrderedList')
      this.btn.insertUnorderedList = document.queryCommandState('insertUnorderedList')
    },
    updateCaretInfo () {
      const sel = window.getSelection()
      this.caret.hasSelection = !sel.isCollapsed // Se o inicio da seleção é igual ao fim
      this.caret.anchorOffset = sel.anchorOffset
      this.caret.anchorElText = sel.getRangeAt(0).startContainer
      this.caret.anchorEl = this.caret.anchorElText.parentNode
      this.returnCaret4Editor()
      this.recursiveNodeSearch(this.caret.anchorEl)
    },
    recursiveNodeSearch (nodeStart, path = '') {
      let range = document.createRange()
      path = nodeStart.nodeName + path
      range.setStartAfter(nodeStart)
      range.collapse(true)
      const pNode = range.startContainer
      if (pNode.nodeName === 'DIV') {
        // console.log('Achei a div' + path)
        this.caret.pathList = (path === 'DIV') ? path : 'Div » ' + path
      } else {
        // console.log('find path...')
        path = ' » ' + path
        this.recursiveNodeSearch(pNode, path)
      }
    },
    handlerMouseDown () {
      // console.log('MouseDown')
      this.updateCaretInfo()
    },
    handlerMouseUp () {
      // console.log('MouseUp')
      this.updateCaretInfo()
    },
    bold (click = false) {
      if (click) this.btn.bold = !this.btn.bold
      document.execCommand('bold', false)
    },
    italic (click = false) {
      if (click) this.btn.italic = !this.btn.italic
      document.execCommand('italic', false)
    },
    underline (click = false) {
      if (click) this.btn.underline = !this.btn.underline
      document.execCommand('underline', false)
    },
    strikeThrough (click = false) {
      if (click) this.btn.strikeThrough = !this.btn.strikeThrough
      document.execCommand('strikeThrough', false)
    },
    superScript (click = false) {
      if (click) this.btn.superScript = !this.btn.superScript
      document.execCommand('superScript', false)
    },
    subScript (click = false) {
      if (click) this.btn.subScript = !this.btn.subScript
      document.execCommand('subScript', false)
    },
    foreColor (click = false) {
      if (click) this.btn.foreColor = !this.btn.foreColor
      document.execCommand('foreColor', false, this.foreColorHex)
    },
    backColor (click = false) {
      if (click) this.btn.backColor = !this.btn.backColor
      document.execCommand('backColor', false, this.backColorHex)
    },
    setColor (color, fob) {
      if (fob === 'b') {
        this.seeBackColors = false
        this.backColorHex = color
      } else {
        this.seeFontColors = false
        this.foreColorHex = color
      }
    },
    insertOrderedList (click = false) {
      if (click) {
        this.btn.insertOrderedList = !this.btn.insertOrderedList
        this.btn.insertUnorderedList = false
      }
      this.returnCaret4LastKnowPosition()
      document.execCommand('insertOrderedList', false)
    },
    insertUnorderedList (click = false) {
      if (click) {
        this.btn.insertUnorderedList = !this.btn.insertUnorderedList
        this.btn.insertOrderedList = false
      }
      this.returnCaret4LastKnowPosition()
      document.execCommand('insertUnorderedList', false)
    },
    justifyLeft () {
      const bool = this.btn.justifyLeft = !this.btn.justifyLeft
      document.execCommand('justifyLeft', false)
      if (bool) {
        this.btn.justifyCenter = this.btn.justifyRight = this.btn.justifyFull = false
      }
    },
    justifyCenter () {
      const bool = this.btn.justifyCenter = !this.btn.justifyCenter
      document.execCommand('justifyCenter', false)
      if (!bool) {
        this.justifyLeft()
      } else {
        this.btn.justifyLeft = this.btn.justifyRight = this.btn.justifyFull = false
      }
    },
    justifyRight () {
      const bool = this.btn.justifyRight = !this.btn.justifyRight
      document.execCommand('justifyRight', false)
      if (!bool) {
        this.justifyLeft()
      } else {
        this.btn.justifyLeft = this.btn.justifyCenter = this.btn.justifyFull = false
      }
    },
    justifyFull () {
      const bool = this.btn.justifyFull = !this.btn.justifyFull
      document.execCommand('justifyFull', false)
      if (!bool) {
        this.justifyLeft()
      } else {
        this.btn.justifyLeft = this.btn.justifyRight = this.btn.justifyCenter = false
      }
    },
    fontSize (size) {
      this.returnCaret4LastKnowPosition()
      document.execCommand('insertHTML', false, '&nbsp;<font size="' + size + '">Titulo</font>&nbsp;')
    },
    createLink () {
      let href = prompt('Digite o endereço da internet...')
      if (href.substr(0, 4).toLowerCase() === 'www.') {
        const txt = window.getSelection().toString()
        document.execCommand('insertHTML', false, '<a href="http://' + href + '" target="_blank">' + txt + '</a>')
      }
    },
    insertImage () {},
    removeFormat (cmdId) {
      document.execCommand('removeFormat', false, cmdId)
    }
  }
}
</script>

<style scoped>
  #wysiwyg {
    margin: auto;
    text-align:left;
  }
  .hide {
    display:none;
  }
  .tools {
    background: -moz-linear-gradient(top, #eeeeee, #bebebe);
    border: 1px solid #bebebe;
    padding: 5px;
  }
  .tools .group-btn {
    display: inline;
    margin-right: 10px;
  }
  .tools .group-btn a:first-child {
    border-radius: 5px 0 0 5px;
  }
  .tools .group-btn a:last-child {
    border-radius: 0 5px 5px 0;
  }
  .tools .group-btn a {
    display: inline-block;
    width: 30px;
    height: 30px;
    font-size: 12px;
    color: #505a64;
    background: #f9f9f9;
    margin-right: -5px;
    text-align: center;
    line-height: 30px;
    border: 1px solid #ccc;
  }
  .tools .group-btn a.on {
    background: -moz-linear-gradient(top,#e1e1e1,#c9c9c9);
    box-shadow: inset 0 0 2px #333;
  }
  .tools .group-btn a:hover {
    color: #f9f9f9;
    background: -moz-linear-gradient(top,#505a64, #616b77, #5d6773);
  }
  #editor {
    border: 1px solid #bebebe;
    min-height: 200px;
    max-height: 400px;
    padding: 20px;
    margin: auto;
    font-size: 16px;
    overflow-y: scroll;
    color: #333;
  }
  #editor:focus {
    outline: none;
  }
  .btn {
    padding: 2px;
  }
  #editor >>> strike {
    color: #888888;
  }
  #editor >>> a {
    text-decoration: underline;
  }
  .resize {
    resize: vertical;
  }
</style>


// WEBPACK FOOTER //
// src/components/Wysiwyg.vue